import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
    paper: {
        maxWidth: '650px'
    }
}));
